import { useEffect, useLayoutEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography, useMediaQuery } from "@mui/material";
import NavGroup from "./NavGroup";
import MenuItems from "../../../../../menu-items";
import { MenuOrientation, HORIZONTAL_MAX_ITEM } from "../../../../../config";
import useConfig from "../../../../../Hooks/useConfig";
import { useSelector } from "../../../../../store";
import { Menu } from "../../../../../menu-items/dashboard";
import { useCurrentPackage } from "../../../../../Hooks/Auth/useCurrentPackage";

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const theme = useTheme();
  const { breadcrumbs } = useSelector((state) => state);
  const { items } = MenuItems(breadcrumbs);
  const { data: ActivePackages, refetch: refetchActivePackage } =
    useCurrentPackage();
  const downLG = useMediaQuery(theme.breakpoints.down("lg"));

  const { menuOrientation } = useConfig();
  const { drawerOpen } = useSelector((state) => state.menu);

  const [selectedItems, setSelectedItems] = useState("");
  const [selectedLevel, setSelectedLevel] = useState(0);
  const [menuItems, setMenuItems] = useState({ items: [] });

  useEffect(() => {
    handlerMenuItem();
    // eslint-disable-next-line
  }, []);

  useLayoutEffect(() => {
    const newMenuItem = items.map((item) => {
      const newChilde = item?.children?.map((subItem) => {
        if (
          subItem?.id === "Bulk Links" &&
          !ActivePackages?.bulk_link_shorting
        ) {
          subItem.is_locked = true;
        } else if (
          subItem?.id === "Link Cloaking" &&
          !ActivePackages?.link_cloaking
        ) {
          subItem.is_locked = true;
        } else if (
          subItem?.id === "Favourite Links" &&
          ActivePackages?.user_active_plan === 1
        ) {
          subItem.is_locked = true;
        } else if (
          subItem?.id === "API Settings" &&
          !ActivePackages?.userApi_add_on
        ) {
          subItem.is_locked = true;
        } else {
          subItem.is_locked = false;
        }
        return subItem;
      });
      item.children = newChilde;
      return item;
    });
    setMenuItems({ items: newMenuItem });
    // eslint-disable-next-line
  }, [ActivePackages]);

  useEffect(() => {
    refetchActivePackage();
  }, []);

  let getMenu = Menu();
  const handlerMenuItem = () => {
    const isFound = items.some((element) => {
      if (element.id === "group-dashboard") {
        return true;
      }
      return false;
    });

    if (getMenu?.id !== undefined && !isFound) {
      items.splice(0, 0, getMenu);
      setMenuItems(items);
    }
  };

  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
  let lastItemIndex = menuItems?.items?.length - 1;
  let remItems = [];
  let lastItemId;

  if (lastItem && lastItem < menuItems.items.length) {
    lastItemId = menuItems.items[lastItem - 1].id;
    lastItemIndex = lastItem - 1;
    remItems = menuItems.items
      ?.slice(lastItem - 1, menuItems.items.length)
      ?.map((item) => ({
        title: item.title,
        elements: item.children,
        icon: item.icon,
      }));
  }

  const navGroups = menuItems.items?.slice(0, lastItemIndex + 1).map((item) => {
    switch (item.type) {
      case "group":
        return (
          <NavGroup
            key={item.id}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedItems={selectedItems}
            lastItem={lastItem}
            remItems={remItems}
            lastItemId={lastItemId}
            item={item}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });
  return (
    <Box
      sx={{
        pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
        "& > ul:first-of-type": { mt: 0 },
        display: isHorizontal ? { xs: "block", lg: "flex" } : "block",
      }}
    >
      {navGroups}
    </Box>
  );
};

export default Navigation;
